<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap">
      <h4>Голосование</h4>
      <div>
        <b-button variant="outline-primary" v-if="!voting" @click="addVoting" class="mb-3">
          <em class="fa fa-plus mr-1"></em> Добавить голосование
        </b-button>
        <b-button variant="outline-primary" class="mb-3" v-else @click="deleteVoting">
          Удалить
        </b-button>
      </div>
    </div>
    <div v-if="voting">
      <div class="my-2">
        <div>Период:</div>
        <b-form-radio-group
          label="Тип голосования"
          v-model="dateLimit"
          :options="dateSettings"
          @change="onAnyChange"
        />
        <div class="d-flex flex-wrap" v-if="dateLimit">
          <div class="mr-2">
            <div>Дата с</div>
            <b-input type="date" v-model="dateStart" :max="dateEnd" @keypress="onDateKeyPress" @change="onAnyChange"/>
          </div>
          <div>
            <div>Дата по</div>
            <b-input type="date" v-model="dateEnd" :min="dateStart" @keypress="onDateKeyPress" @change="onAnyChange"/>
          </div>
        </div>
      </div>
      <div class="d-flex my-2 flex-wrap">
        <div>Количество вариантов:</div>
        <b-input type="number" v-model="variantsCount" min="0" :max="maxTabs" @change="changeVariantCount"/>
      </div>
      <div class="d-flex my-2 flex-wrap">
        <div>Количество ответов:</div>
        <b-input type="number" v-model="answersCount" min="0" :max="variantsCount" @change="changeAnswerCount"/>
      </div>
      <div class="my-2">
        <div>Отображение диаграммы результатов:</div>
        <b-form-radio-group
          label="Отображение диаграммы результатов"
          v-model="diagramStatus"
          :options="diagramOptions"
          @change="onAnyChange"
        />
      </div>
      <b-card v-if="variants && variants.length">
        <b-tabs small card align="center">
          <template v-slot:tabs-end>
            <b-nav-item href="#" @click="() => {}" :active="currentTab === index"
                        v-for="(variant, index) in variants" :key="index">
              <b-badge variant="primary" class="mr-1">{{index+1}}</b-badge>
              <b-button class="mr-1" variant="outline-primary" @click="setSelectedTab(index)">
                <em class="fas fa-lg fa-question"></em>
              </b-button>
            </b-nav-item>
          </template>
          <div class="m-3">
            <div>Название:</div>
            <b-input v-model="variants[currentTab].title" @change="onAnyChange"/>
            <div>Описание:</div>
            <wysiwyg-text-editor
              :data-for-view="variants[currentTab].description"
              @update="updateVariant"
            />
          </div>
          <b-alert show variant="danger" class="mx-3" v-if="emptyVariants.length">
            Незаполненные вкладки: {{ emptyVariants }}
          </b-alert>
        </b-tabs>
      </b-card>
    </div>
    <div v-else>
      <b-alert show variant="info">Голосование отсутствует</b-alert>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import WysiwygTextEditor from '@/components/content/edit/WysiwygTextEditor.vue'

export default {
  name: 'EditVoting',
  components: {
    WysiwygTextEditor
  },
  computed: {
    ...mapGetters({
      updater: 'contentManager/getUpdater',
      content: 'content/getContent'
    }),
    emptyVariants() {
      return this.variants.reduce((arr, variant, i) => ((!variant.title || !variant.description) &&
        arr.push(i + 1), arr), []).join(', ')
    }
  },
  data() {
    return {
      dateSettings: [
        { text: 'Бессрочный', value: false },
        { text: 'Временный', value: true }
      ],
      dateLimit: false,
      voting: null,
      dateStart: null,
      dateEnd: null,
      maxTabs: 20,
      variantsCount: 0,
      answersCount: 1,
      diagramStatus: 0,
      diagramOptions: [
        { text: 'Нет', value: 0 },
        { text: 'После окончания периода', value: 1 },
        { text: 'Всегда', value: 2 }
      ],
      variants: [],
      currentTab: 0
    }
  },
  created() {
    this.voting = this.content.contentObject.votingSettings
      ? _.cloneDeep(this.content.contentObject.votingSettings.choice)
      : null
    if (this.voting) {
      this.dateStart = this.voting.dateStart
      this.dateEnd = this.voting.dateEnd
      this.variants = this.voting.variants
      this.diagramStatus = this.voting.diagramStatus
      this.answersCount = this.voting.answersCount
      this.variantsCount = this.variants.length
      this.dateLimit = this.voting.dateLimit
    } else {
      const currentDate = moment().format('YYYY-MM-DD')
      this.dateStart = currentDate
      this.dateEnd = currentDate
    }
  },
  methods: {
    ...mapActions({
      updateEventVoting: 'contentManager/updateEventVoting',
      updateUpdater: 'contentManager/updateUpdater'
    }),
    ...mapMutations({
      updateContentSavedStatus: 'contentManager/updateContentSavedStatus'
    }),
    addVoting() {
      this.voting = {}
    },
    deleteVoting() {
      this.voting = null
      this.updateUpdater(this.updater + 1)
      this.updateEventVoting(null)
      this.updateContentSavedStatus(false)
    },
    onDateKeyPress(e) {
      e.preventDefault()
      return false
    },
    setSelectedTab(index) {
      this.currentTab = index
    },
    updateVariant(value) {
      this.variants[this.currentTab].description = value
      this.onAnyChange()
    },
    changeVariantCount(value) {
      if (value > this.maxTabs) {
        this.variantsCount = this.maxTabs
        value = this.maxTabs
      } else if (value < 0) {
        this.variantsCount = 0
        value = 0
      }
      if (this.variants.length < value) {
        while (this.variants.length < value) {
          this.variants.push({
            index: this.variants.length,
            title: '',
            description: ''
          })
        }
      } else {
        this.variants.splice(value)
      }
      if (this.answersCount > value) {
        this.answersCount = value
      }
      this.onAnyChange()
    },
    changeAnswerCount(value) {
      if (value > this.variantsCount) {
        this.answersCount = this.variantsCount
        value = this.variantsCount
      } else if (value < 0) {
        this.answersCount = 0
        value = 0
      }
      this.onAnyChange()
    },
    onAnyChange() {
      this.$nextTick(() => {
        this.updateUpdater(this.updater + 1)
        this.updateEventVoting({
          dateLimit: this.dateLimit,
          dateStart: this.dateStart,
          dateEnd: this.dateEnd,
          variants: this.variants,
          answersCount: this.answersCount,
          diagramStatus: this.diagramStatus
        })
        this.updateContentSavedStatus(false)
      })
    }
  }
}
</script>

<style scoped>

</style>
